"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionLost = void 0;
var react_1 = __importDefault(require("react"));
var SessionLost = function () { return (react_1.default.createElement("div", { className: "oidc-session-lost" },
    react_1.default.createElement("div", { className: "oidc-session-lost__container" },
        react_1.default.createElement("h1", { className: "oidc-session-lost__title" }, "Session timed out"),
        react_1.default.createElement("p", { className: "oidc-session-lost__content" }, "Your session has expired. Please re-authenticate.")))); };
exports.SessionLost = SessionLost;
exports.default = exports.SessionLost;
//# sourceMappingURL=SessionLost.component.js.map